<template>
  <div id="app">
    <router-view/>
    <div id="fb-root"></div>
    <div class="fb-customerchat"
    attribution="setup_tool"
    page_id="116243833615369"
    theme_color="#7646ff"
    logged_in_greeting="Hi! How can we help you?"
    logged_out_greeting="Hi! How can we help you?">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // fb login
      profile: {},
      authorized: false,
      // database
      products: [
        // {
        //   title: '',
        //   id: '',
        //   price: 0,
        //   is_new: true,
        //   on_banner: true,
        //   category: [],
        //   images: {
        //     main: '',
        //     banner: '',
        //     others: [],
        //   },
        //   content: '',
        //   description: {
        //     title: '',
        //     text: '',
        //   },
        // },
        {
          title: '黃色鬱金香',
          id: 'UG061',
          price: 999,
          is_new: true,
          on_banner: true,
          category: [
            {
              chinese: '黃黃的',
              english: 'yellow',
            },
            {
              chinese: '沒水果吃',
              english: 'no_fruit',
            },
          ],
          images: {
            main: require('./assets/UG061/1074722c095c5d6c66ce6235a56cb4b1.jpg'),
            banner: require('./assets/UG061/c22c4693d293f670e2242a0a5a866da8.jpg'),
            others: [
              require('./assets/UG061/55cb214ca448f90aae7f4ae9f35ba6c5.jpg'),
              require('./assets/UG061/cb234d2c5e8957e44cd121b4e57bfb6e.jpg'),
            ],
          },
          content: `<p>
  鬱金香（學名：Tulipa gesneriana）是百合科鬱金香屬的一個栽培種，又稱洋荷花、旱荷花。
</p>
<br>
<p>
  絕大多數鬱金香屬栽培品種都屬於本種，其起源地為土耳其，可能起源於眼斑鬱金香（學名：Tulipa
  agenensis）、亞美尼亞鬱金香（學名：Tulipa armena）、準噶爾鬱金香（學名：Tulipa suaveolens）等種的雜交。[1]
</p>
<br>
<p>
  為人熟知的外銷大國荷蘭初次引進鬱金香是在16世紀末，因生長地區緯度不同而花期各異，普遍在3月下旬至5月上旬。雖然全世界約有2,000多個鬱金香品種，但大量生產者大約只有150種。
</p>
<br>
<p>
  被歐洲人稱為「魔幻之花」的鬱金香，自古以來就有一種莫名的魔力使園藝學家熱衷於品種改良，甚至有人傾家蕩產只為了它那稀有的球根[來源請求]。後來鬱金香是成為了荷蘭的國花。
</p>
<br>
<p>
  亞洲很多國家也種植鬱金香，土耳其等國使用他們裝飾，還有伊朗在伊朗國旗和伊朗國徽上也可以看見有鬱金香的圖案。
</p>`,
          description: [
            {
              title: '商品尺寸',
              text: `<ul>
  <li>
    長: 15cm
  </li>
  <li>
    寬: 15cm
  </li>
  <li>
    高: 15cm
  </li>
</ul>`,
            },
            {
              title: '最佳觀賞期',
              text: `<ul>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
</ul>`,
            },
            {
              title: '照顧方式',
              text: `<ul>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
</ul>`,
            },
            {
              title: '付款方式',
              text: `<ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
            },
            {
              title: '運送方式',
              text: `<ul>
  <li>
    黑貓宅配
  </li>
  <li>
    專人配送
  </li>
  <li>
    門市取貨
  </li>
</ul>`,
            },
            {
              title: '購物須知',
              text: `<ul>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
</ul>`,
            },
          ],
        },
        {
          title: '紅色玫瑰花',
          id: 'UB004',
          price: 1314,
          is_new: false,
          on_banner: false,
          category: [
            {
              chinese: '紅紅的',
              english: 'red',
            },
            {
              chinese: '沒水果吃',
              english: 'no_fruit',
            },
          ],
          images: {
            main: require('./assets/UB004/e8aee34a40ce4a0c3ead22f649ee7894.jpg'),
            banner: require('./assets/UB004/3ab36fff3baab97ecf174b5097d52c0b.jpg'),
            others: [
              require('./assets/UB004/16fbb9c53a8779a1ff498b4c78e5f764.jpg'),
              require('./assets/UB004/9353b1ade7f63643be5f18a1fdd0493d.jpg'),
            ],
          },
          content: `<p>在歐洲諸語言中，所有薔薇屬植物都是使用同一個詞，如英語、法文都是rose，德語是die Rose。中國原產的薔薇屬物種以薔薇（R. multiflora）、月季（R. chinensis）和玫瑰（R. rugosa）最為常見，因此rose一詞常翻譯成「薔薇」、「月季」或「玫瑰」，造成名稱使用混亂。</p>
          `,
          description: [
            {
              title: '商品尺寸',
              text: `<ul>
  <li>
    長: 15cm
  </li>
  <li>
    寬: 15cm
  </li>
  <li>
    高: 15cm
  </li>
</ul>`,
            },
            {
              title: '最佳觀賞期',
              text: `<ul>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
</ul>`,
            },
            {
              title: '照顧方式',
              text: `<ul>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
</ul>`,
            },
            {
              title: '付款方式',
              text: `<ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
            },
            {
              title: '運送方式',
              text: `<ul>
  <li>
    黑貓宅配
  </li>
  <li>
    專人配送
  </li>
  <li>
    門市取貨
  </li>
</ul>`,
            },
            {
              title: '購物須知',
              text: `<ul>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
</ul>`,
            },
          ],
        },
        {
          title: '藍色玫瑰花',
          id: 'UG060',
          price: 1520,
          is_new: true,
          on_banner: true,
          category: [
            {
              chinese: '藍藍的',
              english: 'blue',
            },
            {
              chinese: '沒水果吃',
              english: 'no_fruit',
            },
          ],
          images: {
            main: require('./assets/UG060/61769c140faa8de09ec5b1e10b054667.jpg'),
            banner: require('./assets/UG060/1ee48c4dd09fda3a1a10faef4eb42a0f.jpg'),
            others: [
              require('./assets/UG060/7f008db95d06c8dbe2f82d0b385b50b2.jpg'),
              require('./assets/UG060/ea605b52a72ce0c5c2859aeab6e8fe58.jpg'),
            ],
          },
          content: `<p>藍玫瑰包含了基因轉殖的玫瑰品種和染色後的玫瑰。</p>
<p>自然界中並不存在藍色的玫瑰。第一種基因轉殖合成的藍玫瑰品種，由日本三得利公司在2004年首次培育成功[1]，該品種由於含有翠雀花素（一種花青素）而呈色；[2][3]雖然取名「藍玫瑰」，它真正的花色介於薰衣草色和藕合色之間。[4] 天津大學和中科院的研究人員在2018年也用白玫瑰通過基因轉殖技術培育出了藍玫瑰[5]。</p>
<p>藍色妖姬等品種不是真正的藍玫瑰，而是用白玫瑰或白月季染色成的。</p>
<p>在一些文化中，藍玫瑰傳統上與"藍色"皇室血液聯繫在一起，因此藍玫瑰代表王權和輝煌。 由於藍玫瑰實質上的缺失，它們也象徵神秘和渴望實現不可能的事物。[6]</p>`,
          description: [
            {
              title: '商品尺寸',
              text: `<ul>
  <li>
    長: 15cm
  </li>
  <li>
    寬: 15cm
  </li>
  <li>
    高: 15cm
  </li>
</ul>`,
            },
            {
              title: '最佳觀賞期',
              text: `<ul>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
</ul>`,
            },
            {
              title: '照顧方式',
              text: `<ul>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
</ul>`,
            },
            {
              title: '付款方式',
              text: `<ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
            },
            {
              title: '運送方式',
              text: `<ul>
  <li>
    黑貓宅配
  </li>
  <li>
    專人配送
  </li>
  <li>
    門市取貨
  </li>
</ul>`,
            },
            {
              title: '購物須知',
              text: `<ul>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
</ul>`,
            },
          ],
        },
        {
          title: '黃色小雛菊',
          id: 'UG035',
          price: 850,
          is_new: false,
          on_banner: false,
          category: [
            {
              chinese: '黃黃的',
              english: 'yellow',
            },
            {
              chinese: '沒水果吃',
              english: 'no_fruit',
            },
          ],
          images: {
            main: require('./assets/UG035/e86a4340569db741e6f27f0fdbb1e607.jpg'),
            banner: require('./assets/UG035/9ae582904dd0714765e072dce9bd3133.jpg'),
            others: [
              require('./assets/UG035/2826d6eea015c2fed4d727240aa67b97.jpg'),
              require('./assets/UG035/b4572f5ba883caa1c3b30a218246fe3b.jpg'),
            ],
          },
          content: `<p>小雛菊的顏色繁多，每種顏色代表著不同的含義，那麼小雛菊顏色不同花語分別是什麼呢，紫雛菊代表著隱瞞的愛，綠雛菊代表著暗戀，白雛菊代表著純潔的美，黃雛菊代表著和平、希望，藍雛菊代表著幸福、純潔、天真的意思，分別適合送給身邊不同的人。</p>
<p>黃雛菊在小雛菊的品種中是十分常見的，雖然顏色沒有什麼特殊的地方，但是黃雛菊代表的含義十分豐富，它代表著和平、希望的顏色，適合送給身邊朋友、親人、愛人等各種場合，可以增加兩人之間的友情、感情。</p>`,
          description: [
            {
              title: '商品尺寸',
              text: `<ul>
  <li>
    長: 15cm
  </li>
  <li>
    寬: 15cm
  </li>
  <li>
    高: 15cm
  </li>
</ul>`,
            },
            {
              title: '最佳觀賞期',
              text: `<ul>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
</ul>`,
            },
            {
              title: '照顧方式',
              text: `<ul>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
</ul>`,
            },
            {
              title: '付款方式',
              text: `<ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
            },
            {
              title: '運送方式',
              text: `<ul>
  <li>
    黑貓宅配
  </li>
  <li>
    專人配送
  </li>
  <li>
    門市取貨
  </li>
</ul>`,
            },
            {
              title: '購物須知',
              text: `<ul>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
</ul>`,
            },
          ],
        },
        {
          title: '藍色薰衣草',
          id: 'UG050',
          price: 2050,
          is_new: true,
          on_banner: true,
          category: [
            {
              chinese: '藍藍的',
              english: 'blue',
            },
            {
              chinese: '沒水果吃',
              english: 'no_fruit',
            },
          ],
          images: {
            main: require('./assets/UG050/2e34e68a7dc33dc2a634585fb4271b9e.jpg'),
            banner: require('./assets/UG050/8825f9e77655b58539eba0f7baa03e57.jpg'),
            others: [
              require('./assets/UG050/45ab049212fab22cb82d9774791b72a5.jpg'),
              require('./assets/UG050/53d23594142c97ef976235568b8d7468.jpg'),
            ],
          },
          content: `<p>薰衣草屬（學名：Lavandula）是唇形科的一個屬，約有25-30種。多年生草本、亞灌木或小灌木[1]。</p>
<p>原產地由地中海地區（如西班牙、葡萄牙）、南至熱帶非洲、東至印度，包括加那利群島、非洲北部和東部、歐洲南部、地中海地區、阿拉伯半島和印度等地區。</p>
<p>狹葉薰衣草（又叫真薰衣草或英國薰衣草）原産於地中海的西部，它的出油率較高，出油品質最高。提鍊後得到的精油可以直接在皮膚上使用。主要種植地是歐洲的英國，保加利亞的高山地區，大洋洲的澳大利亞和中國大陸的甘肅清水地區少量種植。</p>`,
          description: [
            {
              title: '商品尺寸',
              text: `<ul>
  <li>
    長: 15cm
  </li>
  <li>
    寬: 15cm
  </li>
  <li>
    高: 15cm
  </li>
</ul>`,
            },
            {
              title: '最佳觀賞期',
              text: `<ul>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
</ul>`,
            },
            {
              title: '照顧方式',
              text: `<ul>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
</ul>`,
            },
            {
              title: '付款方式',
              text: `<ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
            },
            {
              title: '運送方式',
              text: `<ul>
  <li>
    黑貓宅配
  </li>
  <li>
    專人配送
  </li>
  <li>
    門市取貨
  </li>
</ul>`,
            },
            {
              title: '購物須知',
              text: `<ul>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
</ul>`,
            },
          ],
        },
        {
          title: '蘭花',
          id: 'LG011',
          price: 1800,
          is_new: false,
          on_banner: false,
          category: [
            {
              chinese: '白白的',
              english: 'white',
            },
            {
              chinese: '沒水果吃',
              english: 'no_fruit',
            },
          ],
          images: {
            main: require('./assets/LG011/8e2691d4897c02207eea570a0ef0d2de.jpg'),
            banner: require('./assets/LG011/aed6f57ffe1dd8195118c5483a886a25.jpg'),
            others: [
              require('./assets/LG011/d951cb3b496fdfdab0013fec544bddfb.jpg'),
            ],
          },
          content: `<p>蘭花是很多人心目中最想養的花卉，也是很多人養不好的花卉。蘭花在中國歷來被看做是高潔典雅的象徵，並與「梅、竹、菊」並列，合稱「四君子」。那麼蘭花是如何養殖的呢？</p>
<p>一，蘭花的最佳生長土壤：蘭花用土應以腐殖質為主，主要採用腐葉土或山林腐殖土。在南方用原產地的腐殖土，俗稱蘭花泥；也可用腐葉土、蛭石、珍珠岩等及人工配製成疏鬆、通氣、透水的培養土。所配製培養土均是呈微酸性的。選配不當，保水性太強或澆水過頻，導致土壤老是濕漉漉的。當這種過濕狀態持續時間超過蘭花所能的忍受限度時，蘭根就腐爛了，蘭株最終死亡。此外，也有人聽說蘭花「怕」水，就很少給它澆水，結果矯枉過正，蘭花被「渴死」了，這種情況也有的。由此可見，能否掌控好土壤中的含水量，是決定養蘭成敗的關鍵。</p>
<p>二，最佳生長溫度和澆水：蘭花生長適宜溫度為16～24℃。冬夏都要注意溫度的控制。</p>`,
          description: [
            {
              title: '商品尺寸',
              text: `<ul>
  <li>
    長: 15cm
  </li>
  <li>
    寬: 15cm
  </li>
  <li>
    高: 15cm
  </li>
</ul>`,
            },
            {
              title: '最佳觀賞期',
              text: `<ul>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
</ul>`,
            },
            {
              title: '照顧方式',
              text: `<ul>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
</ul>`,
            },
            {
              title: '付款方式',
              text: `<ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
            },
            {
              title: '運送方式',
              text: `<ul>
  <li>
    黑貓宅配
  </li>
  <li>
    專人配送
  </li>
  <li>
    門市取貨
  </li>
</ul>`,
            },
            {
              title: '購物須知',
              text: `<ul>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
</ul>`,
            },
          ],
        },
        {
          title: '水蜜桃禮盒',
          id: 'PH004',
          price: 2680,
          is_new: true,
          on_banner: true,
          category: [
            {
              chinese: '紅紅的',
              english: 'red',
            },
            {
              chinese: '有水果吃',
              english: 'with_fruit',
            },
          ],
          images: {
            main: require('./assets/PH004/894480a22d67a46a9b8b6a256f9af6e9.jpg'),
            banner: require('./assets/PH004/57ecb7ae85d328c29c1920cd1619db40.jpg'),
            others: [
              require('./assets/PH004/39dba23df52b66b8c311d802d880cb27.jpg'),
              require('./assets/PH004/f920d09e6f0a5cda0c3a14f77253300b.jpg'),
            ],
          },
          content: `<p>桃（學名：Prunus persica）是薔薇科李屬的一種，花可以觀賞，果實多汁，作為水果，可以生食或製桃脯、罐頭等，核仁也可以食用。

  果肉有白色和黃色的，一般在日本最受歡迎的品種多為白色果肉，香甜多汁；歐洲、澳洲和北美洲的人則在歷史上喜歡黃色果肉較酸的品種。</p>
<p>桃原產於中國，最遠可以追溯到周朝，《詩經·國風·周南》即有〈桃夭〉一詩，逐漸傳播到亞洲周邊地區，從波斯傳入西方，桃的種小名「persica」意思就是波斯的水果。</p>
<p>桃是一種溫帶植物，需要一定的夏日光照但晚上要比較涼爽的氣溫及充足的水分和肥料，而且不耐旱。一般用嫁接法種植。把樹型要修整為張開的手掌形以使各部分能獲得充分的陽光（和蘋果要有一個向上的中心領導枝不同），桃園和蘋果園可以從樹型上很容易地區別。</p>`,
          description: [
            {
              title: '商品尺寸',
              text: `<ul>
  <li>
    長: 15cm
  </li>
  <li>
    寬: 15cm
  </li>
  <li>
    高: 15cm
  </li>
</ul>`,
            },
            {
              title: '最佳觀賞期',
              text: `<ul>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
</ul>`,
            },
            {
              title: '照顧方式',
              text: `<ul>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
</ul>`,
            },
            {
              title: '付款方式',
              text: `<ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
            },
            {
              title: '運送方式',
              text: `<ul>
  <li>
    黑貓宅配
  </li>
  <li>
    專人配送
  </li>
  <li>
    門市取貨
  </li>
</ul>`,
            },
            {
              title: '購物須知',
              text: `<ul>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
</ul>`,
            },
          ],
        },
        {
          title: '粉紅玫瑰',
          id: 'FV068',
          price: 1314,
          is_new: false,
          on_banner: false,
          category: [
            {
              chinese: '紅紅的',
              english: 'red',
            },
            {
              chinese: '沒水果吃',
              english: 'no_fruit',
            },
          ],
          images: {
            main: require('./assets/FV068/b2afebe130ce13231e1d35e668eca253.jpg'),
            banner: require('./assets/FV068/4c30cd364d805c69067b7e4c5694aa89.jpg'),
            others: [
              require('./assets/FV068/6aa8bc1e626160446e6d660356ca6dd4.jpg'),
            ],
          },
          content: `<p>玫瑰一直是愛情的象徵，沒有人不喜愛玫瑰。而粉紅色玫瑰更是女人們的最好，那粉紅色玫瑰花語是什麼呢?粉紅色玫瑰花語代表著什麼呢?今天小編就給大家講一講，補充一下知識。</p>
<p>【粉紅色玫瑰花語】</p>
<p>粉色玫瑰花語就和粉玫瑰的顏色一樣，帶著淡淡的粉色，粉玫瑰花語的內容是這樣的：初戀，特別的關懷，喜歡你那燦爛的微笑。粉玫瑰花語還是與美好的愛情有關，而且是純真的初戀哦。

  送花對象：愛人、情人
  
  花語：感動、愛的宣言、銘記於心 、初戀，喜歡你那燦爛的笑容，粉玫瑰贈予給堅實的愛情。彼此寄託，彼此信任。一縷微笑，絕代佳人，像雪一樣白，像月亮一樣亮。一花一鳥，一樹一石，一山一水，都負荷著無限的深意、無邊的情誼。一念花開，一念花落。roseonly以可愛嬌嫩之粉玫瑰，與愛配料，調製魔藥，您親吻花瓣之時，魔力揮散，與佳人廝守，即得堅實的愛情。</p>`,
          description: [
            {
              title: '商品尺寸',
              text: `<ul>
  <li>
    長: 15cm
  </li>
  <li>
    寬: 15cm
  </li>
  <li>
    高: 15cm
  </li>
</ul>`,
            },
            {
              title: '最佳觀賞期',
              text: `<ul>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
</ul>`,
            },
            {
              title: '照顧方式',
              text: `<ul>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
</ul>`,
            },
            {
              title: '付款方式',
              text: `<ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
            },
            {
              title: '運送方式',
              text: `<ul>
  <li>
    黑貓宅配
  </li>
  <li>
    專人配送
  </li>
  <li>
    門市取貨
  </li>
</ul>`,
            },
            {
              title: '購物須知',
              text: `<ul>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
</ul>`,
            },
          ],
        },
        {
          title: '草莓禮盒',
          id: 'SB014',
          price: 2688,
          is_new: false,
          on_banner: false,
          category: [
            {
              chinese: '紅紅的',
              english: 'red',
            },
            {
              chinese: '有水果吃',
              english: 'with_fruit',
            },
          ],
          images: {
            main: require('./assets/SB014/e298a71fed3f63ef2a6fd363649cd94d.jpg'),
            banner: require('./assets/SB014/8ebfbbdc7a95f4401002dd1ae9550393.jpg'),
            others: [
              require('./assets/SB014/e2ba4176fd04f354a569f27239e2a9f5.jpg'),
              require('./assets/SB014/5473841147f184ad659ddc641bb4620b.jpg'),
            ],
          },
          content: `<p>草莓（學名：Fragaria × ananassa），為草莓屬中最常見的雜交栽培種。也常指其果實。草莓是多年生草本植物，一般存活時間為3年左右。在中國大陸和台灣稱草莓，香港稱為士多啤梨。</p>
<p>最佳的保存環境是保存在接近零度但不結霜的冰箱。除此之外，亦有使用紫外線或惰性氣體保存。急凍亦是其中有效的保存方法。洗草莓時，先輕輕洗淨再去掉蒂頭，可避免維生素C流失，附著在草莓上的雜質，也不會在清洗過程中從蒂頭跑進去。</p>
<p>在早晨或傍晚採收，新鮮食用宜在成熟至八成時採收，加工用的只要在著色七至八成便可。採摘時必須保留半厘米至一厘米的果梗，太長的話容易損害其他草莓。</p>`,
          description: [
            {
              title: '商品尺寸',
              text: `<ul>
  <li>
    長: 15cm
  </li>
  <li>
    寬: 15cm
  </li>
  <li>
    高: 15cm
  </li>
</ul>`,
            },
            {
              title: '最佳觀賞期',
              text: `<ul>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
</ul>`,
            },
            {
              title: '照顧方式',
              text: `<ul>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
</ul>`,
            },
            {
              title: '付款方式',
              text: `<ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
            },
            {
              title: '運送方式',
              text: `<ul>
  <li>
    黑貓宅配
  </li>
  <li>
    專人配送
  </li>
  <li>
    門市取貨
  </li>
</ul>`,
            },
            {
              title: '購物須知',
              text: `<ul>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
</ul>`,
            },
          ],
        },
        {
          title: '蒲公英',
          id: 'UB005',
          price: 680,
          is_new: true,
          on_banner: true,
          category: [
            {
              chinese: '白白的',
              english: 'white',
            },
            {
              chinese: '沒水果吃',
              english: 'no_fruit',
            },
          ],
          images: {
            main: require('./assets/UB005/4dcd1f8d37c692feb1a401c7d16b624e.jpg'),
            banner: require('./assets/UB005/5b72a9a700b20db128bc60ca209f15f1.jpg'),
            others: [
              require('./assets/UB005/6e7c6f3124341aa94e5615a5d91707ba.jpg'),
              require('./assets/UB005/9e1b23b12fb18af8f731d7d6e95bb705.jpg'),
              require('./assets/UB005/e606ca644fa803c2a013bc169626d34f.jpg'),
            ],
          },
          content: `<p>蒲公英屬（學名：Taraxacum）植物通稱蒲公英、黃花地丁、婆婆丁，華花郎、蒲公草、食用蒲公英、尿床草、西洋蒲公英，為菊目菊科的一屬，是溫帶至亞熱帶常見的一種植物。蒲公英採孤雌生殖，葉邊的形狀像獅子的尖牙。其英文名字Dandelion來自法語dent-de-lion，正是獅子牙齒之意，蒲公英花語為我在遠處為你的幸福而祈禱。</p>
<p>蒲公英為多年生草本植物，花莖是空心的，折斷之後有白色的乳汁。匙形或狹長倒卵形的葉子呈蓮座狀平鋪，羽狀淺裂或齒裂。</p>
<p>早春的嫩蒲公英也是一種野菜。現在已經有家養出來的，比野生的大很多。嫩蒲公英可以涼拌、燒湯或炒熟。老了的也能吃，但是比較苦。不苦的蒲公英也可以拌肉作餃子餡，味道和西洋菜做的餡差不多。歐洲人在中世紀時就已經用蒲公英花來釀酒。蒲公英葉子含有很多維生素A和維生素C。 蜜蜂也常到蒲公英採集花粉和蜜糖。</p>`,
          description: [
            {
              title: '商品尺寸',
              text: `<ul>
  <li>
    長: 15cm
  </li>
  <li>
    寬: 15cm
  </li>
  <li>
    高: 15cm
  </li>
</ul>`,
            },
            {
              title: '最佳觀賞期',
              text: `<ul>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
  <li>
    最佳觀賞期
  </li>
</ul>`,
            },
            {
              title: '照顧方式',
              text: `<ul>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
  <li>
    照顧方式
  </li>
</ul>`,
            },
            {
              title: '付款方式',
              text: `<ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
            },
            {
              title: '運送方式',
              text: `<ul>
  <li>
    黑貓宅配
  </li>
  <li>
    專人配送
  </li>
  <li>
    門市取貨
  </li>
</ul>`,
            },
            {
              title: '購物須知',
              text: `<ul>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
  <li>
    購物須知購物須知購物須知購物須知購物須知
  </li>
</ul>`,
            },
          ],
        },
      ],
      news: [
        // {
        //   id: '',
        //   title: '',
        //   date: '',
        //   description: '',
        //   banner: '',
        //   content: '',
        //   remark: '',
        // },
        {
          id: 'NEW2020080501',
          title: '客製化花藝也能做電商，佈局「數位虛擬花店」',
          date: '2020-08-05',
          description: `
          <p>2020 年零售業者因新冠肺炎疫情影響紛紛開展線上通路，仍有不少店家因為商品性質而觀望不前。以婚宴會場、精品活動合作聞名的花藝店「花意空間」，卻超前部署拓展電商通路，透過客製化的花束搶佔線上商機、更在今年母親節檔期利用線上網店提升品牌曝光，大幅增加品牌的會員與 LINE 好友數，以利進行顧客再行銷。透過電商通路作為銷售生力軍，結合實體店面提供的專業花藝服務，在疫情間仍創下好的銷售成績，正是花意空間把握數位轉型的美好成果。</p>
          `,
          banner: require('./assets/NEW2020080501/a8725cb076653957a52d4079b6465679.jpg'),
          content: `<p>重新定義花店概念，「花意空間」透過電商讓消費者也能下單客製化花藝</p>
<p>於 1996 成立於台北的花意空間，為台灣最具規模的花店之一，創辦人師承法國有名花藝師，為了把法國的工藝及美學透過實體的花藝佈置傳達給更多台灣人。如今花意空間在台灣已有兩間實體店面，在上海更成立旗艦店和四家分店，除了提供客製化花藝服務、會場佈置外，近期更發展花藝課程。</p>
<p>經營即將邁向 25 年的花意空間，仍致力在經營模式上追求創新，年初雖然有許多實體店面受疫情影響，但花意空間團隊卻早已進行數位轉型，並透過 SHOPLINE 開啟電商經營之路，讓喜愛精緻花藝的朋友們能夠不受疫情限制，隨時訂購花束、即時掌握花店資訊。</p>`,
          remark: `
          <br>1、 櫻花
<br>搖曳英華揮冷月 橫斜倩影弄余香
<br>芳心蕩破春歸路 落瓣如刀斷客腸
<br>
<br>2、 菊花
<br>獨立西風寧自黃 孤標能傲九秋霜
<br>非凡志醞非凡品 自在花開自在香
<br>
<br>3、 桃花
<br>麗影繽紛迎暖日 紅妝窈窕綻芳叢
<br>勸君惜取三春色 莫負東風萬點紅
<br>
<br>4、 杜鵑
<br>過眼斑斕花弄影 彤彤開似錦霞迎
<br>子規啼卻心頭血 片片紅云動客情
<br>`,
        },
        {
          id: 'NEW2020041401',
          title: '（歷史消息）台北年後賞花指南！士林官邸、陽明山等4處免費觀賞',
          date: '2020-04-14',
          description: `
          <p>假日賞花何處去？盤點台北市2020年第一季賞花指南，台北市即將登場的花季活動，除士林官邸梅花、陽明山的櫻花，還有鬱金香，草花花海圖等，均可免費參觀。</p><p>
率先登場的是「2020樂活夜櫻季」將於2月2日開幕至3月1日，屆時可到內湖樂活公園漫步河畔，欣賞夜空為背景、絢爛燈光點綴的櫻花步道。公園處還設計櫻花郵筒，2月22日前開放索取限量明信片傳情。</p>`,
          banner: require('./assets/NEW2020041401/2fbd10de1252bd22ad1a4cfed008b5be.jpg'),
          content: `<p>
「士林官邸鬱金香展」則在西洋情人節2月14日揭幕，至2月23日，每日上午8時至下午18時開放參觀，展場以日本、荷蘭鬱金香妝點布置，營造夢幻鬱金香花海，在市區就有被花朵簇擁的幸福感，展場規畫共計35個攤位。同時士林官邸自大年初一起展出春節花卉展至3月1日，可依同享受喜氣洋洋的花之饗宴，室內展館開放時間是上午8點30分至下午5點。</p><p>
成美右岸河濱公園用多達6萬盆當季花草打造542坪的2區花海，如四季秋海棠、一串紫、金魚草、情人菊等，自即日起可以一路觀賞至明年2月上旬。</p><p>
北市觀山河濱公園基隆河5號疏散門前使用約7萬6千多盆當季草花打造2067平方公尺的花海，透過一串紅、一串紫、四季秋海棠、孔雀草、黃花瑪格麗特、非洲鳳仙花、香堇菜、三色堇，以及大眾十分喜愛的羽葉薰衣草鋪排充滿生命力的幾何圖騰。目前約有7成以上草花盛開，花況預計元宵節前全面盛開，可一路觀賞至3月下旬。</p>`,
          remark: `
                    <br>1、 櫻花
          <br>搖曳英華揮冷月 橫斜倩影弄余香
          <br>芳心蕩破春歸路 落瓣如刀斷客腸
          <br>
          <br>2、 菊花
          <br>獨立西風寧自黃 孤標能傲九秋霜
          <br>非凡志醞非凡品 自在花開自在香
          <br>
          <br>3、 桃花
          <br>麗影繽紛迎暖日 紅妝窈窕綻芳叢
          <br>勸君惜取三春色 莫負東風萬點紅
          <br>
          <br>4、 杜鵑
          <br>過眼斑斕花弄影 彤彤開似錦霞迎
          <br>子規啼卻心頭血 片片紅云動客情
          <br>`,
        },
      ],
      orderInfos: [
        {
          index: 'ois1',
          title: '訂購方式',
          content: `<ul>
    <li>線上訂購<br>
        線上選購 &gt; 加入購物車&nbsp;&gt; 填寫訂購資料&nbsp;&gt;&nbsp;進行結帳 &gt; 訂購完成。</li>
    <li>Line或FB訂購<br>
        將欲訂購的商品及配送資訊，傳送至Line或FB粉絲專頁。</li>
</ul>`,
        },
        {
          index: 'ois2',
          title: '付款方式',
          content: `            <ul>
<li>ATM</li>
<li>信用卡</li>
<li>超商付款</li>
<li>門市付款</li>
</ul>`,
        },
        {
          index: 'ois3',
          title: '運送方式',
          content: `<p>＊因每樣商品不同，我們為您安排適當配送方式。</p>

<ul>
    <li>專人配送<br>
        專人配送時間為週一至週日<br>
        上午 08：00－13：00、下午 14：00－18：00。<br>
    </li>
    <li>黑貓宅配<br>
        使用訂製宅配箱出貨，提供商品完整保護，並由台灣地區最好的物流進行配送。<br>
        鮮花類商品一律使用低溫宅配出貨，確保商品送達時保持完好狀態。<br>
    </li>
    <li>門市取貨<br>
        門市營業時間: 週一至週日08:00-20:00</li>
</ul>

<p>＊因每樣商品不同，我們為您安排適當配送方式。</p>`,
        },
        {
          index: 'ois4',
          title: '照顧方式',
          content: `<p>如何照顧自己的盆栽植物，你知道嗎，教你小方法</p>
<ul>
    <li>在花盆下放一個碟子，以承接排水。 碟子可以防止髒水直接流在你的地板、窗台或書桌上。</li>
    <li>當土壤乾燥時或按照植物標籤上的指示澆水。</li>
    <li>添加慢速釋放肥料，或如標籤所建議的施肥。</li>
    <li>每當你看到枯葉時就修剪你的植物。</li>
    <li>切斷植物的任何部分腐爛或真菌並注意對付害蟲。</li>
</ul>`,
        },
      ],
      /* eslint-disable */
      mails: [
        {"id":"james1615132581975","time":1615132562000,"name":"郭達軒","tel":"0975938293","mail":"hugh820816@gmail.com","content":"夜來風雨聲，花落知多少","read":true,"reply":{"id":"mailReply1615132857760","time":"1615132857760","name":"James3","content":"ㄏㄏ"}},
        {
          id: 'mail1612182786000',
          time: '1612182786000',
          name: '郭達軒',
          tel: '0975938293',
          mail: 'hugh820816@gmail.com',
          content: 'No this is Patrick.',
          read: true,
          reply: {
            id: 'mailReply1612182786000',
            time: '1612182786000',
            name: 'James',
            content: 'Hello this is reply',
          },
        },
        {
          id: 'mail1611164799000',
          time: '1611164799000',
          name: 'Hey hey hey',
          tel: '0975123456',
          mail: 'ooxx@ooxx.com',
          content: '花間一壺酒 獨酌無相親',
          read: false,
          reply: {
            id: '',
            time: '',
            name: '',
            content: '',
          },
        },
      ],
      orders: [
        {"sum":6497,"createTime":1615019980462,"id":"PO1615019980462","memberId":"james","cart":{"sum":7197,"products":[{"img":"img/1074722c095c5d6c66ce6235a56cb4b1.19d6e974.jpg","title":"黃色鬱金香","id":"UG061","price":999,"quantity":3},{"img":"img/894480a22d67a46a9b8b6a256f9af6e9.827b77e4.jpg","title":"水蜜桃禮盒","id":"PH004","price":2680,"quantity":1},{"img":"img/61769c140faa8de09ec5b1e10b054667.62be6b9d.jpg","title":"藍色玫瑰花","id":"UG060","price":1520,"quantity":1}]},"coupon":{"id":"save100","description":"滿千送百(單筆累計)","availableLogic":{"_custom":{"type":"function","display":"<span>ƒ</span> availableLogic(cart)"}},"discount":-700,"discountLogic":{"_custom":{"type":"function","display":"<span>ƒ</span> discountLogic(cart)"}}},"buyer":{"name":"郭達軒","tel":"0975938293","email":"hugh820816@gmail.com"},"invoice":{"type":"donation","donationTarget":"donationCompany2"},"recipient":{"ifGetFromStore":false,"info":{"name":"123","tel":"123456789","address":"651 雲林縣北港鎮999888777","ifRepresentative":true,"representativeTitle":"778899"},"ifAnonymous":false,"esdDate":"2021-03-17","esdTime":"morning","cardContent":"505050","remark":"303030"},"payment":{"ifPaid":false},"sending":{"isSent":false},},
        {"sum":10800,"createTime":1615020611689,"id":"PO1615020611689","memberId":"","cart":{"sum":10800,"products":[{"img":"img/8e2691d4897c02207eea570a0ef0d2de.215fb38e.jpg","title":"蘭花","id":"LG011","price":1800,"quantity":6}]},"coupon":{"id":"","discount":0},"buyer":{"name":"qqq","tel":"www","email":"eee@rrr"},"invoice":{"type":"person","personCarrier":"no","personCarrierAddress":"605 嘉義縣阿里山wwwsssxxx"},"recipient":{"ifGetFromStore":true,"info":{"name":"","tel":"","address":"","ifRepresentative":false,"ifAnonymous":false},"ifAnonymous":false,"esdDate":"2021-03-20","esdTime":"","cardContent":"efef","remark":"fwfwfwf"},"payment":{"ifPaid":true,"info":{"type":"creditCard","creditNumber":"asdasd","creditExp":{"month":"aaa","year":"sss"},"creditCvc":"ddd","time":"2021-03-07 13:44:31","status":"paid"}},"sending":{"isSent":false},},
        {"sum":20600,"createTime":1615111459095,"id":"PO1615111459095","memberId":"james","cart":{"sum":22800,"products":[{"img":"img/61769c140faa8de09ec5b1e10b054667.62be6b9d.jpg","title":"藍色玫瑰花","id":"UG060","price":1520,"quantity":15}]},"coupon":{"id":"save100","description":"滿千送百(單筆累計)","availableLogic":{"_custom":{"type":"function","display":"<span>ƒ</span> availableLogic(cart)"}},"discount":-2200,"discountLogic":{"_custom":{"type":"function","display":"<span>ƒ</span> discountLogic(cart)"}}},"buyer":{"name":"郭達軒","tel":"0975938293","email":"hugh820816@gmail.com"},"invoice":{"type":"person","personCarrier":"mobile","personCarrierMobile":"/asdfgef"},"recipient":{"ifGetFromStore":false,"info":{"name":"qwe","tel":"qweqwe","address":"922 屏東縣來義鄉3c3c3c3c","ifRepresentative":true,"representativeTitle":"jjjjj","ifAnonymous":true},"ifAnonymous":false,"esdDate":"2021-03-24","esdTime":"afternoon","cardContent":"oooo","remark":"iiiii"},"payment":{"ifPaid":true,"info":{"type":"creditCard","creditNumber":"ffffff","creditExp":{"month":"vvv","year":"vvv"},"creditCvc":"ddd","time":"2021-03-07 18:05:25"}},"sending":{"ifSent":false}},
      ],
      /* eslint-enable */
      coupons: [
        {
          id: 'save100',
          description: '滿千送百(單筆累計)',
          availableLogic(cart) {
            const cartSum = cart.sum;
            let boolean;
            if (cartSum >= 1000) {
              boolean = true;
            } else {
              boolean = false;
            }
            return boolean;
          },
          discount: 0,
          discountLogic(cart) {
            const discount = -(Math.floor(cart.sum / 1000) * 100);
            return discount;
          },
        },
        {
          id: '20off',
          description: '隨機三樣享八折優惠',
          availableLogic(cart) {
            let cartProductQuantity = 0;
            cart.products.forEach((item) => {
              cartProductQuantity += item.quantity;
            });
            let boolean;
            if (cartProductQuantity >= 3) {
              boolean = true;
            } else {
              boolean = false;
            }
            return boolean;
          },
          discount: 0,
          discountLogic(cart) {
            const discount = -(Math.floor(cart.sum * 0.2));
            return discount;
          },
        },
      ],
      members: [
        {
          id: 'james',
          name: '郭達軒',
          gender: 'male',
          birthday: '1993-08-16',
          tel: '0975938293',
          email: 'hugh820816@gmail.com',
          password: 'hugh820816',
          favorites: ['UB004', 'SB014'],
        },
        {
          id: 'fb__3700959833274377',
          name: 'test_james_fb',
          gender: 'male',
          birthday: '1968-10-12',
          tel: '091235678',
          email: 'testfb@test.com',
          password: 'password123',
          favorites: ['UB005', 'SB014', 'UG050'],
        },
        {
          id: '123456',
          name: 'sherry',
          gender: 'female',
          birthday: '2000-01-01',
          tel: '0987654321',
          email: 'sherry@sherry.com',
          password: '55555555',
          favorites: ['UG035'],
        },
      ],
      administrators: [
        {
          id: 'admin_james',
          name: 'James',
          account: 'admin',
          password: 'admin',
          level: 1,
        },
        {
          id: 'admin_james2',
          name: 'James2',
          account: 'admin2',
          password: 'admin2',
          level: 2,
        },
        {
          id: 'admin_james3',
          name: 'James3',
          account: 'admin3',
          password: 'admin3',
          level: 3,
        },
        {
          id: 'admin_james4',
          name: 'James4',
          account: 'admin4',
          password: 'admin4',
          level: 4,
        },
      ],
      // using data
      member: {
        id: '',
        name: '',
        gender: '',
        birthday: '',
        tel: '',
        email: '',
        password: '',
        favorites: [],
      },
      administrator: {
        id: 'admin_james3',
        name: 'James3',
        account: 'admin3',
        password: 'admin3',
        level: 3,
      },
    };
  },
  methods: {
    makeToast(color, content) {
      const nowTime = new Date();
      const timeConvert = (time) => {
        const h = time.getHours();
        const m = time.getMinutes();
        const s = time.getSeconds();
        const hh = h > 9 ? h : `0${h}`;
        const mm = m > 9 ? m : `0${m}`;
        const ss = s > 9 ? s : `0${s}`;
        return `${hh}:${mm}:${ss}`;
      };
      this.$bvToast.toast(content, {
        variant: color,
        title: `系統訊息 ${timeConvert(nowTime)}`,
        autoHideDelay: 5000,
      });
    },
    go_page(route) {
      this.$router.push(route);
    },
    /* eslint-disable */
    fb_login() {
      const resposeFunc = (res) => {
        if (res.status === 'connected') {
          // fb授權成功
          FB.api('/me?fields=name,id,email', (response) => {
            const memberId = `fb__${response.id}`;
            const ifHasMember = this.members.findIndex((item) => item.id === memberId);
            if (ifHasMember < 0) {
              // 首次使用fb登入，註冊並登入
              const newMember = {
                id: memberId,
                name: `${response.name}`,
                gender: '',
                birthday: '',
                tel: '',
                email: `${response.email}`,
                password: '',
                favorites: [],
              };
              this.register(newMember);
              this.login(memberId);
            } else {
              // 非首次使用fb登入，直接登入
              this.login(memberId);
            }
          });
        } else {
          // fb授權失敗
          this.$bus.$emit('show_toast', 'warning', 'FB 授權登入失敗');
        }
      };
      const fbScope = {
        scope: 'email, public_profile',
        return_scopes: true,
      };
      FB.login(
          (response) => {
            resposeFunc(response);
          },
          fbScope
      );
    },
    /* eslint-enable */
    login(id) {
      const thisMember = this.members.find((item) => item.id === id);
      this.member = thisMember;
      this.$bus.$emit('show_toast', 'success', '登入成功');
    },
    logout() {
      this.member = {
        id: '',
        name: '',
        gender: '',
        birthday: '',
        tel: '',
        email: '',
        password: '',
        favorites: [],
      };
      this.$bus.$emit('show_toast', 'success', '登出成功');
      this.go_page('');
    },
    register(newMember) {
      this.members.push(newMember);
      this.$bus.$emit('show_toast', 'success', '註冊成功');
    },
  },
  created() {
    this.$bus.$on('son_call_data', () => {
      this.$bus.$emit('son_get_data', this.$data);
    });
    this.$bus.$on('show_toast', (color, content) => {
      this.makeToast(color, content);
    });

    this.$bus.$on('add_new_mail', (mail) => {
      this.mails.push(mail);
      this.$bus.$emit('show_toast', 'success', '發送信件成功');
    });
    this.$bus.$on('toggle_mail_read', (id, boolean) => {
      const oriMailIndex = this.mails
        .findIndex((item) => item.id === id);
      this.mails[oriMailIndex].read = boolean;
    });
    this.$bus.$on('submit_mailReply', (id, replyObj) => {
      const tMailIndex = this.mails
        .findIndex((item) => item.id === id);
      this.mails[tMailIndex].reply = replyObj;
      this.$bus.$emit('show_toast', 'success', '回覆信件成功');
    });

    this.$bus.$on('add_new_member', (member) => {
      this.register(member);
    });
    this.$bus.$on('delete_member', (id) => {
      const oriMemberIndex = this.members.findIndex((item) => item.id === id);
      this.members.splice(oriMemberIndex, 1);
      this.$bus.$emit('show_toast', 'success', '刪除會員成功');
    });

    this.$bus.$on('log_in', (member) => {
      this.login(member.id);
    });
    this.$bus.$on('log_out', () => {
      this.logout();
    });
    this.$bus.$on('fb_login', (boolean) => {
      if (boolean) {
        this.fb_login();
        // profile: {email: '', id: '', name: ''},
      }
    });

    this.$bus.$on('edit_favorite', (id, boolean) => {
      if (boolean) {
        this.member.favorites.push(id);
      } else {
        const idIndex = this.member.favorites.findIndex((item) => item === id);
        this.member.favorites.splice(idIndex, 1);
      }
    });

    this.$bus.$on('add_new_order', (newOrder) => {
      this.orders.push(newOrder);
    });
    this.$bus.$on('make_payment', (id, payment) => {
      const paidOrder = this.orders.find((item) => item.id === id);
      paidOrder.payment.info = payment;
      paidOrder.payment.ifPaid = true;
      this.$bus.$emit('show_toast', 'success', `訂單${id}付款完成`);
    });
    this.$bus.$on('delete_order', (orderId) => {
      const thisOrderIndex = this.orders.findIndex((item) => item.id === orderId);
      this.orders.splice(thisOrderIndex, 1);
      this.$bus.$emit('show_toast', 'success', `訂單${orderId}已刪除`);
    });

    this.$bus.$on('admin_login', (admin) => {
      this.administrator = admin;
    });
    this.$bus.$on('admin_logout', () => {
      this.administrator = {
        id: '',
        name: '',
        account: '',
        password: '',
      };
    });

    this.$bus.$on('add_new_product', (product) => {
      const repeatP = this.products.find((item) => item.id === product.id);
      if (repeatP !== undefined) {
        this.$bus.$emit('show_toast', 'warning', '產品ID重複，新增失敗');
      } else {
        const newP = JSON.parse(JSON.stringify(product));
        this.products.push(newP);
        this.$bus.$emit('show_toast', 'success', '新增商品成功');
      }
    });
    this.$bus.$on('edit_product', (product) => {
      const newP = JSON.parse(JSON.stringify(product));
      const newId = newP.id;
      const oldIndex = this.products.findIndex((item) => item.id === newId);
      this.products[oldIndex] = newP;
      this.$bus.$emit('show_toast', 'success', '變更商品成功');
    });
    this.$bus.$on('delete_product', (product) => {
      const theId = product.id;
      const theIndex = this.products.findIndex((item) => item.id === theId);
      this.products.splice(theIndex, 1);
    });

    this.$bus.$on('add_new_news', (nNews) => {
      this.news.push(nNews);
      this.$bus.$emit('show_toast', 'success', '新增新聞成功');
    });
    this.$bus.$on('edit_news', (newsObj) => {
      const thisId = newsObj.id;
      const oriNewsObjIndex = this.news.findIndex((item) => item.id === thisId);
      this.news[oriNewsObjIndex] = newsObj;
      this.$bus.$emit('show_toast', 'success', '編輯新聞內容成功');
    });
    this.$bus.$on('delete_news', (newsId) => {
      const oriNewsObjIndex = this.news.findIndex((item) => item.id === newsId);
      this.news.splice(oriNewsObjIndex, 1);
      this.$bus.$emit('show_toast', 'success', '刪除新聞成功');
    });

    this.$bus.$on('add_new_ois', (newOis) => {
      this.orderInfos.push(newOis);
      this.$bus.$emit('show_toast', 'success', '購物指南新增成功');
    });
    this.$bus.$on('edit_ois', (oisObj) => {
      const oriOisIndex = this.orderInfos.findIndex((item) => item.id === oisObj.id);
      this.orderInfos[oriOisIndex] = oisObj;
      this.$bus.$emit('show_toast', 'success', '購物指南編輯成功');
    });
    this.$bus.$on('delete_ois', (oisId) => {
      const oriOisIndex = this.orderInfos.findIndex((item) => item.id === oisId);
      this.orderInfos.splice(oriOisIndex, 1);
      this.$bus.$emit('show_toast', 'success', '購物指南刪除成功');
    });

    this.$bus.$on('add_new_coupon', (couponObj) => {
      this.coupons.push(couponObj);
      this.$bus.$emit('show_toast', 'success', '優惠券新增成功');
    });
    this.$bus.$on('edit_coupon', (couponObj, oriIndex) => {
      this.coupons[oriIndex] = couponObj;
      this.$bus.$emit('show_toast', 'success', '優惠券編輯成功');
    });
    this.$bus.$on('delete_coupon', (couponIndex) => {
      this.coupons.splice(couponIndex, 1);
      this.$bus.$emit('show_toast', 'success', '優惠券刪除成功');
    });

    this.$bus.$on('add_new_admin', (adminObj) => {
      this.administrators.push(adminObj);
      this.$bus.$emit('show_toast', 'success', '管理員新增成功');
    });
    this.$bus.$on('edit_admin', (adminIndex, adminObj) => {
      this.administrators[adminIndex] = adminObj;
      this.$bus.$emit('show_toast', 'success', '管理員資料更新成功');
    });
    this.$bus.$on('delete_admin', (id) => {
      const targetIndex = this.administrators.findIndex((item) => item.id === id);
      this.administrators.splice(targetIndex, 1);
      this.$bus.$emit('show_toast', 'success', '管理員刪除成功');
    });

    this.$bus.$on('send_order', (orderList) => {
      orderList.forEach((orderId) => {
        const thisOrderIndex = this.orders.findIndex((item) => item.id === orderId);
        this.orders[thisOrderIndex].sending.ifSent = true;
        const newSendingInfo = {
          sentTime: (new Date()).getTime(),
        };
        this.orders[thisOrderIndex].sending.info = newSendingInfo;
        this.$bus.$emit('show_toast', 'success', `訂單${orderId}出貨成功`);
      });
    });
  },
  mounted() {
    /* eslint-disable */
    window.fbAsyncInit = function () {
      FB.init({
      appId: "256052322609908",
      cookie: true,
      xfbml: true,
      version: "v10.0",
      });
      FB.AppEvents.logPageView();
    };
    /* eslint-enable */
    document.title = '艸芊芳苑 | FLORAL DESIGN';
  },
};
</script>
